import { EventCallback } from '@otto-ec/global-resources/event-q-bus';

export interface ProductTracking {
    /**
 *
 */
    eventMergeId?: string;
}

export interface ProductState {
    /**
 *
 */
    isVariationChanged?: boolean;
}

export interface ProductData {
    /**
 *
 */
    enteredArticleNumberAndPromotion?: string;
}

export interface GlobalOProduct {
    /**
 *
 *
 */
    tracking: ProductTracking;

    state: ProductState;

    data: ProductData;
    reloadCallbacks: EventCallback[];
    debug: boolean;
}

declare global {
    var o_product: GlobalOProduct;
}

export function initializeOProduct() {
    if (!window.o_product) {
        window.o_product = {
            tracking: {},
            state: {},
            data: {},
            reloadCallbacks: [],
            debug: false,
        };
    }
    if (!window.o_product.tracking) {
        window.o_product.tracking = {};
    }

    if (!window.o_product.state) {
        window.o_product.state = { isVariationChanged: false };
    }

    if (!window.o_product.data) {
        window.o_product.data = {};
    }
    if (!window.o_product.reloadCallbacks) {
        window.o_product.reloadCallbacks = [];
    }
}
